import { useEffect, useState } from "react";

const useDebounce = (value, delay, loader = null) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    if (loader) loader(true);
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};

export default useDebounce;
